import { render, staticRenderFns } from "./HoraPeriodo.vue?vue&type=template&id=0b2ea11e"
import script from "./HoraPeriodo.vue?vue&type=script&lang=js"
export * from "./HoraPeriodo.vue?vue&type=script&lang=js"
import style0 from "./HoraPeriodo.vue?vue&type=style&index=0&id=0b2ea11e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports